<template class="">
  
  <div>
    <div class="background">
      <div class="backgroundImage" :style="{ backgroundImage: `url('${organizationBackground}')` }"></div>
      <div class="background-overlay"></div>
    </div>

    <div class="header">
      <div class="headerNode text-secondary">
        
        <a href="#" v-on:click.prevent="setLang('it')">ITA</a>
        <a href="#" v-on:click.prevent="setLang('en')">ENG</a>

      </div>
    </div>

    <div class="outer">
      <div class="middle">
        <div class="inner">
          <router-link to="/" class="text-center domainLogo">
            <div :style="{ backgroundImage: `url('${organizationThumbnail}')` }"></div>
          </router-link>

          <h5 class="domainName">{{organizationName}}</h5>

          <router-view></router-view>

        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footerNode text-secondary">
        
        <span>
          <a href="https://beebeeboard.com" target="_blank">Beebeeboard</a>
        </span>

        <a href="https://beebeeboard.com/termini-e-condizioni" target="_blank">
          {{ $t('label.termsOfServices') }}
        </a>

        <a href="https://beebeeboard.com/normativa-privacy" target="_blank">
          {{ $t('label.privacyPolicy') }}
        </a>

      </div>
    </div>

  </div>

</template>

<script>
import './assets/css/foundation.min.css'
import './assets/css/loading.css'
import './assets/css/loading-btn.css'
import './assets/css/main.css'

import axios from 'axios'
import * as CONFIG from './config'

export default {
  name: 'app',

  data: () => ({
    organizationThumbnail: null,
    organizationBackground: null,
    organizationName: '',
    openRegistration: false,
    organizationLegal: '',
    view: ''
  }),

  created () {
    var self = this

    if (window.location.protocol !== 'https:' && process.env.NODE_ENV !== 'development') {
      window.location = location.href.replace('http://', 'https://')
    }

    axios.get(`${CONFIG.BASEURL}/api/v1/organizations/open`)
    .then(response => {
      self.openRegistration = response.data.data.attributes.new_registration
      self.organizationName = response.data.data.attributes.name
      self.organizationLegal = response.data.data.attributes.gdpr_legal

      if (response.data.data.attributes.thumbnail_url) {
        self.organizationThumbnail = `${CONFIG.DATAURL}/${response.data.data.attributes.thumbnail_url}-medium.jpeg`
      } else {
        self.organizationThumbnail = require(`@/assets/img/beebee.png`)
      }

      if (response.data.data.attributes.copertina_url) {
        self.organizationBackground = `${CONFIG.DATAURL}/${response.data.data.attributes.copertina_url}`
      } else {
        if (response.data.data.attributes.redirect_url_admin === 'clinic') {
          let rand = Math.floor((Math.random() * 3) + 1)
          self.organizationBackground = require(`@/assets/img/background_clinic/active-${rand}.jpg`)
        } else {
          let rand = Math.floor((Math.random() * 6) + 1)
          self.organizationBackground = require(`@/assets/img/background/active-${rand}.jpg`)
        }
      }
    })
  },

  methods: {
    setLang (lang) {
      this.$i18n.locale = lang
    }
  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue